import { render, staticRenderFns } from "./IdentificationMainInfo.vue?vue&type=template&id=60fc657c&scoped=true"
import script from "./IdentificationMainInfo.vue?vue&type=script&lang=js"
export * from "./IdentificationMainInfo.vue?vue&type=script&lang=js"
import style0 from "./IdentificationMainInfo.vue?vue&type=style&index=0&id=60fc657c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc657c",
  null
  
)

export default component.exports